import { HttpErrorResponse } from '@angular/common/http';

export class HandleError {

    private static _bmwError: any = {};

    constructor() { }

    /**
     * Handle Http operation that failed. Let the app continue.
     */
    public static handleAPIError(err: HttpErrorResponse): string {
        if (err.error instanceof Error) {
            this._bmwError.message = 'Oops... There was problem, please try again.';
            this._bmwError.flag = true;
            // this.bmwError.message = err.message;
            // Print error message to console so let user debug
            console.error('Client-side error occured. message = ' + err.message);
            return this._bmwError;
        } else {
            this._bmwError.message = 'Oops... Connecion problem, sorry for inconvenience';
            this._bmwError.flag = true;
            // this.bmwError.message = err.message;
            // Print error message to console so let user debug
            console.error('Server-side error occured. message = ' + err.message);
            return this._bmwError;
        }
    }

    public static resetErrorMessage(): void {
        this._bmwError = {
            message: 'Loading data. Please wait...',
            flag: true
        }
    }

    public bmwAppError(): any {
        return HandleError._bmwError;
    }

}
